import {config} from '@modules/config';

export const interFontFace = `
/* Inter Regular */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 400;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-regular.e226d8e173551f5742af606dc1d0b184fe38ef38.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-regular.2ac284d7ba9dd63e691ea7afc14d163891a6a9bb.woff')
			format('woff');
}

/* Inter Medium */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 500;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-medium.3f7a742daef8d40e07155f98f56b44fe7a191d94.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-medium.ea1690ab8e1d656a89c529bb003d08a36c70481a.woff')
			format('woff');
}

/* Inter Semibold */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 600;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-semibold.621d67ce7463019c98c7473ab8677841ff24b1fd.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-semibold.12858343548d78b46410bee99a30aed4ba830817.woff')
			format('woff');
}

/* Inter Bold */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 700;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-bold.041da318cff68d04380ea1e5d16390c5de1fa47d.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-bold.8fbb01ba66d2a2ed461d4459f73236231bd5188f.woff')
			format('woff');
}

/* Inter Black */

@font-face {
	font-display: swap;
	font-family: 'Inter';
	font-style: normal;
	font-weight: 900;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-black.94e79dcafe6559210293515752fcae20329e1083.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/inter/inter-black.50170d884099471742152d0191b49a9a80873200.woff')
			format('woff');
}
`;

export const deezerProductFontFace = `
/* Deezer Light */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 300;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Light.efd35bdb0915246feab41d1358b8cd5085fd20cd.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Light.cfee2dd7c4becdda1c9e8e9d9f4b6ba61f361bc3.woff')
			format('woff');
}

/* Deezer Regular */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 400;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Regular.70f89899e36fd31e61516d3d8735072f84e1834c.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Regular.fdde3d408773a19ee0b563751b99c4480516924d.woff')
			format('woff');
}

/* Deezer Medium */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 500;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Medium.daf0b392651bce99e22271f127d6798f00f7a1f7.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Medium.58cb919ec641feddea21f6a7afd51060691af3ce.woff')
			format('woff');
}

/* Deezer Bold */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 700;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Bold.12a16421bc0c1a0e11b324a8ba1f3035aae0ada2.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Bold.14ce4332645cb3ca0f164d257e880853ed262798.woff')
			format('woff');
}

/* Deezer Extra Bold */
@font-face {
	font-display: swap;
	font-family: 'Deezer Product';
	font-style: normal;
	font-weight: 800;
	src:
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Extrabold.ff5d8428e4fe802f91d53a06857feb145b0a435d.woff2')
			format('woff2'),
		url('${config.get('commonAssetsUrl')}/fonts/deezer-product/DeezerProduct-Extrabold.a1c06d3aa3a0d709767a0e592c1bac25af1f6944.woff')
			format('woff');
}
`;
